import { lazy } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import ProtectedRoute from './components/auth/ProtectedRoute'
import PublicOnlyRoute from './components/auth/PublicOnlyRoute'
import MainLayout from './components/layout/MainLayout'

// Lazy load pages
const Login = lazy(() => import('./components/pages/Login'))
const Register = lazy(() => import('./components/pages/Register'))
const ForgotPassword = lazy(() => import('./components/pages/ForgotPassword'))
const ResetPassword = lazy(() => import('./components/pages/ResetPassword'))
const Home = lazy(() => import('./components/pages/Home'))
const ProfileContainer = lazy(() => import('./components/pages/Settings/SettingsContainer'))
const ProfileBrowser = lazy(() => import('./components/pages/ProfileBrowser'))
const UserLists = lazy(() => import('./components/pages/UserLists/UserLists'))
const PublicProfile = lazy(() => import('./components/pages/PublicProfile'))
const ItemCatalog = lazy(() => import('./components/pages/ItemCatalog'))
const ItemDetailPage = lazy(() => import('./components/pages/ItemDetailPage'))
const NotFound = lazy(() => import('./components/pages/NotFound'))
const ListDetail = lazy(() => import('./components/pages/ListDetail/ListDetail'))
const ListBrowser = lazy(() => import('./components/pages/ListBrowser'))
const TermsOfService = lazy(() => import('./components/pages/TermsOfService'))
const PrivacyPolicy = lazy(() => import('./components/pages/PrivacyPolicy'))
const VerifyEmail = lazy(() => import('./components/pages/VerifyEmail'))
const ConfirmEmail = lazy(() => import('./components/pages/ConfirmEmail'))

export const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route
          element={
            <PublicOnlyRoute>
              <MainLayout />
            </PublicOnlyRoute>
          }
        >
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
        </Route>

        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/items" element={<ItemCatalog />} />
          <Route path="/items/:id" element={<ItemDetailPage />} />
          <Route path="/settings" element={<ProfileContainer />} />
          <Route path="/profiles" element={<ProfileBrowser />} />
          <Route path="/profiles/:id" element={<PublicProfile />} />
          <Route path="/lists/:id" element={<ListDetail />} />
          <Route path="/lists" element={<ListBrowser />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
        </Route>

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/my-lists" element={<UserLists />} />
          <Route path="/my-lists/:id" element={<ListDetail />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  )
}
